import { createStrictContext } from 'utils/createContext'
import { GetCasSubtypesQueryResult, useGetCasSubtypesQuery } from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useProjectContext } from 'context/ProjectContext'

export type CASSubtype = NonNullable<
  GetCasSubtypesQueryResult['data']
>['casSubtypes']['records'][0]

const { Provider, useContextFn } = createStrictContext<
  Pick<GetCasSubtypesQueryResult, 'refetch'> & {
    records: CASSubtype[]
    fetching: GetCasSubtypesQueryResult['loading']
  }
>('SubtypesTableContext')

export const useSubtypesTableContext = useContextFn

export const SubtypesTableProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const {
    data,
    refetch,
    loading: fetching,
  } = useGetCasSubtypesQuery({
    ...DefaultQueryHookOptions,
    variables: {
      casSubtypeListInput: { projectId: { equals: projectId } },
    },
  })
  return (
    <Provider
      value={{ records: data?.casSubtypes?.records ?? [], refetch, fetching }}
    >
      {children}
    </Provider>
  )
}
